import profilepic from "../images/profilepic.svg";
import "../styles/Home.css";
import { useData } from "../providers/ContextProvider";
import { ReactComponent as StreakIcon } from "../images/fire.svg";
import { ReactComponent as LeagueIcon } from "../images/shield.svg";

function ProfileCard() {
  const { state, dispatch } = useData();
  const { userStats } = state;
  return (
    <div className="profile-card">
      <img src={profilepic} alt="profile-pic" className="profile-pic" />
      <div className="user-stats">
        <div className="stats-heading">USER STATS</div>
        <div className="stats-section">
          <div className="stats-icon">
            <StreakIcon />
          </div>
          <div className="stats">
            <div className="stats-value">{userStats.currentStreak}</div>
            <div className="stats-desc"> Day Streak</div>
          </div>
        </div>
        <div className="stats-section">
          <div className="stats-icon">
            <LeagueIcon />
          </div>
          <div className="stats">
            <div className="stats-value">{userStats.currentLeague}</div>
            <div className="stats-desc"> Current League</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ProfileCard };
